import moment from 'moment'

moment.locale('pt-br')

const blank = {
  preferences: {
    customers_widget_showaddress: false,
    sound: true
  },
  options: {
    delivery_fee: 0,
    default_state: '',
    default_city: ''
  },
  schedule: {
    id: 0,
    order: -1,
    list: [],
    title: '',
    duration: 0,
    employees: [],
    customer: {
      id: -1,
      name: '',
      phone: '',
      identity: '',
      birth_date: '',
      cep: '',
      address: '',
      num: '',
      com: '',
      state: null,
      city: null
    },
    selected: []
  },
  order: {
    customer: {
      id: -1,
      phone: '',
      name: '',
      identity: '',
      birth_date: '',
      address: {
        cep: '',
        address: '',
        num: '',
        comp: '',
        neighborhood: '',
        state: null,
        city: null
      },
      confirm: false
    },
    payment: {
      income: [],
      paid: [],
      full_paid: false
    },
    order: {
      list: {
        services: [],
        items: []
      },
      obs: '',
      subtotal: 0.00,
      total: 0.00
    },
    schedules: [],
    delivery: [],
    comissions: [],
    actions: {
      status: 1,
      paid: false,
      print: true
    }
  },
  payment: {
    id: 0,
    UUID: -1,
    cat: '',
    type: 1,
    title: '',
    value: 0,
    tax: 0,
    percent: 0,
    delete: 0
  },
  service: {
    id: 0,
    title: '',
    cat: 0,
    price: 0,
    description: '',
    active: true,
    catalog: 'services'
  },
  item: {
    id: 0,
    title: '',
    cat: 0,
    price: 0,
    description: '',
    photo: '',
    active: true,
    stock: 0,
    qty: 0,
    catalog: 'items'
  },
  category (catalog) {
    return {
      id: 0,
      name: '',
      parent: 0,
      active: 1,
      children: {},
      catalog
    }
  },
  additional (catalog) {
    return {
      id: 0,
      title: '',
      cat: 0,
      price: 0,
      description: '',
      active: true,
      catalog
    }
  },
  customer: {
    id: 0,
    name: '',
    phone: '',
    identity: '',
    birth_date: '',
    addresses: [],
    historic: []
  },
  financial: {
    periodicals: {
      bills: {
        id: 0,
        type: 2,
        ref: 0,
        period: 1,
        date: 1,
        title: null,
        value: 0
      },
      salary: {
        id: 0,
        type: 1,
        ref: 0,
        period: 1,
        date: 1,
        title: null,
        value: 0
      }
    },
    cashflow: {
      type: 1,
      id: 0,
      datetime: moment().format('YYYY-MM-DD HH:mm:ss'),
      title: '',
      description: '',
      value: '',
      category: 1,
      meta: [
        ['', '', '']
      ]
    },
    bills: {
      type: 2,
      id: 0,
      datetime: moment().format('YYYY-MM-DD HH:mm:ss'),
      title: `Contas ${moment().format('MMMM [de] YYYY')}`,
      description: '',
      value: '',
      category: 2,
      meta: []
    },
    salary: {
      type: 2,
      id: 0,
      datetime: moment().format('YYYY-MM-DD HH:mm:ss'),
      title: '',
      description: '',
      value: '',
      category: 1,
      meta: []
    }
  },
  user: {
    id: 0,
    name: '',
    login: '',
    pass: '',
    pass_confirm: '',
    function_id: 0,
    cat: [],
    no_cat: false,
    avatar: ''
  },
  permission: {
    id: 0,
    name: '',
    color: 'blue',
    permissions: {
      home: false,
      scheduler: false,
      orders: false,
      catalog: false,
      customers: false,
      historic: false,
      users: false,
      config: false,
      profile: false,
      admin: false
    }
  }
}

export default blank
